import React, { Fragment } from 'react'
import MEModal from '../../components/MEModal'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { archiveSection } from '../actions'
import ButterToast, { Cinnamon } from 'butter-toast'
import { Button, MenuItem } from 'react-bootstrap'

class ArchiveSectionModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.submit = this.submit.bind(this)
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  async submit() {
    let data = {
      section_id: this.props.sectionId,
      pageNum: this.props.currentCourseMemPage,
      archivedPageNum: this.props.currentArchivePage,
    }
    this.toggleModal()

    let resp = await this.props.archiveSection(data)
    if (resp.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Section Archived"
            content="Successfully archived section."
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      let error = resp.error
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
      })
    }
  }

  render() {
    return (
      <Fragment>
        <MenuItem onClick={this.toggleModal} className="me-list-item">
          <div className="fal fa-archive mr-2 fa-fw color_teal" />
          Archive Students
        </MenuItem>
        <MEModal
          show={this.state.modalOpen}
          close={this.toggleModal}
          title={'Archive Section'}
        >
          <form onSubmit={e => e.preventDefault()}>
            <p>
              Are you sure you want to archive all students in section{' '}
              {this.props.sectionName}?
            </p>
            <Button
              className="btn-myed btn-primary-myed"
              type="button"
              bsStyle="primary"
              onClick={this.submit}
            >
              Submit
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

ArchiveSectionModal.propTypes = {
  sectionId: PropTypes.string,
  sectionName: PropTypes.string,
  archiveSection: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    currentCourseMemPage: state.currentCourseMemPage,
    currentArchivePage: state.currentArchivePage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    archiveSection: section => {
      let resp = dispatch(archiveSection(section))
      return resp
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveSectionModal)
